import { friendlyErrorMessage } from '@/core/lib/dbError'
import { signAnwesenheitslisteOnGate } from '@/core/api/portal'

const SIGN_ANWESENHEITSLISTE_ERROR =
  "Teilnehmendenliste konnte nicht signiert werden. Bitte versuchen Sie es erneut."

export async function signAnwesenheitsliste(
  coachingId: string,
  signaturePng: string,
): Promise<void> {
  try {
    await signAnwesenheitslisteOnGate(coachingId, signaturePng)
  } catch (error) {
    throw new Error(friendlyErrorMessage(error, SIGN_ANWESENHEITSLISTE_ERROR))
  }
}
